import { GET_SET } from '@api/queriesV2/cms';
import { GET_WIDGET, GET_WIDGET_ADMIN } from "@api/queriesV2/cms";
import { useQuery, useLazyQuery } from '@apollo/client';
import { toast } from 'react-toastify';

// Define a function for shared onCompleted and onError callbacks
const handleCommonEvents = ({ dataObjectName, functionName, onError = null, onCompleted = null, onCompleteWithError = null }) => ({
  onCompleted: (data) => {
    const error = data[dataObjectName];

    if (error?.ErrorCode) {
      onCompleteWithError && onCompleteWithError(data);
      return toast.error(`[${functionName}][${error.ErrorCode}]: ${error.ErrorReason}`);
    }

    onCompleted && onCompleted(data);
  },
  onError: (error) => {
    onError && onError();
    return toast.error(`[useGetSet][${error.name}]: ${error.message}`);
  },
});

export const useGetSet = ({ options = {}, lazy = false, onError, onCompleted, onCompleteWithError }) => {
  // Merge custom options with the default ones
  const mergedOptions = {
    ...handleCommonEvents({ dataObjectName: 'getSet', functionName: 'useGetSet', onError, onCompleted, onCompleteWithError }),
    context: { clientName: "v2" },
    ...options,
  };

  if (lazy) {
    const [getSet, result] = useLazyQuery(GET_SET, mergedOptions);
    return [getSet, { ...result }];
  }

  const result = useQuery(GET_SET, mergedOptions);

  return { ...result };
};

export const useGetWidget = ({ options = {}, lazy = false, onError, onCompleted, onCompleteWithError }) => {
  // Merge custom options with the default ones
  const mergedOptions = {
    ...handleCommonEvents({ dataObjectName: 'getWidget', functionName: 'useGetWidget', onError, onCompleted, onCompleteWithError }),
    context: { clientName: "v2" },
    fetchPolicy: "network-only",
    ...options,
  };

  if (lazy) {
    const [getWidget, result] = useLazyQuery(GET_WIDGET, mergedOptions);
    return [getWidget, { ...result }];
  }

  const result = useQuery(GET_WIDGET, mergedOptions);

  return { ...result };
};

export const useGetWidgetAdmin = ({ options = {}, lazy = false, onError, onCompleted, onCompleteWithError }) => {
  // Merge custom options with the default ones
  const mergedOptions = {
    ...handleCommonEvents({ dataObjectName: 'adminGetWidget', functionName: 'useGetWidgetAdmin', onError, onCompleted, onCompleteWithError }),
    context: { clientName: "v2" },
    fetchPolicy: "network-only",
    ...options,
  };

  if (lazy) {
    const [getWidgetAdmin, result] = useLazyQuery(GET_WIDGET_ADMIN, mergedOptions);
    return [getWidgetAdmin, { ...result }];
  }

  const result = useQuery(GET_WIDGET_ADMIN, mergedOptions);

  return { ...result };
};